export default __webpack_public_path__ + "static/media/T-shirt3.d1c36625.jpg";